import React, { FC } from 'react';
import { ReactComponent as Edit } from '../../../assets/Common/Edit.svg';

export const EditIcon: FC = () => <Edit />;
